(function () {
  var lightboxEl = null;
  var lightboxImg = null;
  var lightboxPrev = null;
  var lightboxNext = null;
  var lightboxClose = null;
  var lightboxCounter = null;
  var lightboxSlides = [];
  var lightboxIndex = 0;
  var lightboxRequestId = 0;
  var preloadCache = {};

  function ensureLightbox() {
    if (lightboxEl) return;

    lightboxEl = document.createElement('div');
    lightboxEl.className = 'fabric-lightbox';
    lightboxEl.setAttribute('role', 'dialog');
    lightboxEl.setAttribute('aria-modal', 'true');
    lightboxEl.setAttribute('aria-label', 'Fabric image viewer');
    lightboxEl.innerHTML =
      '<div class="fabric-lightbox__dialog">' +
        '<button type="button" class="fabric-lightbox__close" data-fabric-lightbox-close aria-label="Close">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
            '<path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>' +
        '<button type="button" class="fabric-lightbox__nav fabric-lightbox__nav--prev" data-fabric-lightbox-prev aria-label="Previous image">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
            '<path d="M13 7H1M6 2L1 7l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</button>' +
        '<img class="fabric-lightbox__img" src="" alt="Fabric image">' +
        '<button type="button" class="fabric-lightbox__nav fabric-lightbox__nav--next" data-fabric-lightbox-next aria-label="Next image">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
            '<path d="M1 7h12M8 2l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</button>' +
        '<span class="fabric-lightbox__counter" data-fabric-lightbox-counter></span>' +
      '</div>';

    document.body.appendChild(lightboxEl);

    lightboxImg = lightboxEl.querySelector('.fabric-lightbox__img');
    lightboxPrev = lightboxEl.querySelector('[data-fabric-lightbox-prev]');
    lightboxNext = lightboxEl.querySelector('[data-fabric-lightbox-next]');
    lightboxClose = lightboxEl.querySelector('[data-fabric-lightbox-close]');
    lightboxCounter = lightboxEl.querySelector('[data-fabric-lightbox-counter]');

    lightboxClose.addEventListener('click', closeLightbox);
    lightboxPrev.addEventListener('click', function () { showLightboxSlide(lightboxIndex - 1); });
    lightboxNext.addEventListener('click', function () { showLightboxSlide(lightboxIndex + 1); });

    lightboxEl.addEventListener('click', function (e) {
      if (e.target === lightboxEl) closeLightbox();
    });

    document.addEventListener('keydown', function (e) {
      if (!lightboxEl.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showLightboxSlide(lightboxIndex - 1);
      if (e.key === 'ArrowRight') showLightboxSlide(lightboxIndex + 1);
    });
  }

  function updateLightboxControls() {
    var multiple = lightboxSlides.length > 1;
    lightboxPrev.classList.toggle('is-hidden', !multiple);
    lightboxNext.classList.toggle('is-hidden', !multiple);
    lightboxCounter.classList.toggle('is-hidden', !multiple);
    if (multiple) {
      lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + lightboxSlides.length;
    }
  }

  function preloadUrl(url) {
    if (!url || preloadCache[url]) return preloadCache[url];
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
    preloadCache[url] = img;
    return img;
  }

  function setLightboxImage(url, requestId) {
    if (!url || !lightboxImg) return;

    function apply() {
      if (requestId !== lightboxRequestId) return;
      lightboxImg.src = url;
      lightboxImg.classList.remove('is-loading');
    }

    var cached = preloadCache[url];
    if (cached && cached.complete && cached.naturalWidth) {
      apply();
      return;
    }

    var loader = preloadUrl(url);
    if (loader.complete && loader.naturalWidth) {
      apply();
      return;
    }

    loader.addEventListener('load', apply, { once: true });
    loader.addEventListener('error', function () {
      if (requestId !== lightboxRequestId) return;
      lightboxImg.classList.remove('is-loading');
    }, { once: true });
  }

  function showLightboxSlide(index) {
    if (!lightboxSlides.length) return;
    lightboxIndex = (index + lightboxSlides.length) % lightboxSlides.length;
    var slide = lightboxSlides[lightboxIndex];
    var requestId = ++lightboxRequestId;

    lightboxImg.alt = 'Fabric image ' + (lightboxIndex + 1);
    updateLightboxControls();

    var preview = slide.preview || slide.zoom;
    var zoom = slide.zoom || slide.preview;

    // Show the already-loaded gallery image immediately, then upgrade to zoom.
    if (preview) {
      lightboxImg.src = preview;
    }

    if (zoom && zoom !== preview) {
      lightboxImg.classList.add('is-loading');
      setLightboxImage(zoom, requestId);
    } else {
      lightboxImg.classList.remove('is-loading');
    }

    // Warm adjacent slides while the lightbox is open.
    if (lightboxSlides.length > 1) {
      var next = lightboxSlides[(lightboxIndex + 1) % lightboxSlides.length];
      var prev = lightboxSlides[(lightboxIndex - 1 + lightboxSlides.length) % lightboxSlides.length];
      if (next && next.zoom) preloadUrl(next.zoom);
      if (prev && prev.zoom) preloadUrl(prev.zoom);
    }
  }

  function openLightbox(slides, startIndex) {
    if (!slides || !slides.length) return;
    ensureLightbox();
    lightboxSlides = slides.map(function (slide) {
      if (typeof slide === 'string') {
        return { zoom: slide, preview: slide };
      }
      return {
        zoom: slide.zoom || slide.preview || '',
        preview: slide.preview || slide.zoom || ''
      };
    }).filter(function (slide) {
      return slide.zoom || slide.preview;
    });
    if (!lightboxSlides.length) return;

    showLightboxSlide(startIndex || 0);
    lightboxEl.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightboxEl) return;
    lightboxRequestId += 1;
    lightboxEl.classList.remove('is-open');
    lightboxImg.classList.remove('is-loading');
    lightboxSlides = [];
    if (!document.querySelector('.fabrics__modal-backdrop.is-open')) {
      document.body.style.overflow = '';
    }
  }

  function getGallerySlides(gallery) {
    var slides = [];
    gallery.querySelectorAll('[data-fabric-gallery-slide] img').forEach(function (img) {
      slides.push({
        preview: img.currentSrc || img.src || '',
        zoom: img.getAttribute('data-zoom-src') || img.currentSrc || img.src || ''
      });
    });
    return slides;
  }

  function preloadGallery(gallery) {
    if (!gallery) return;
    getGallerySlides(gallery).forEach(function (slide) {
      if (slide.zoom) preloadUrl(slide.zoom);
    });
  }

  function getActiveSlideIndex(gallery) {
    var slides = gallery.querySelectorAll('[data-fabric-gallery-slide]');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function showGallerySlide(gallery, index) {
    var slides = gallery.querySelectorAll('[data-fabric-gallery-slide]');
    if (!slides.length) return;
    var nextIndex = (index + slides.length) % slides.length;
    slides.forEach(function (slide, idx) {
      slide.classList.toggle('is-active', idx === nextIndex);
    });
    var counter = gallery.querySelector('[data-fabric-gallery-counter]');
    if (counter) counter.textContent = (nextIndex + 1) + ' / ' + slides.length;
    gallery._fabricGalleryIndex = nextIndex;

    // Preload the newly active slide's zoom image.
    var activeImg = slides[nextIndex] && slides[nextIndex].querySelector('img');
    if (activeImg) {
      var zoomSrc = activeImg.getAttribute('data-zoom-src');
      if (zoomSrc) preloadUrl(zoomSrc);
    }
  }

  function bindGalleryControls(gallery) {
    if (gallery._fabricGalleryClickBound) return;
    gallery._fabricGalleryClickBound = true;

    gallery.addEventListener('click', function (e) {
      if (e.target.closest('[data-fabric-gallery-prev]')) {
        e.preventDefault();
        e.stopPropagation();
        showGallerySlide(gallery, (gallery._fabricGalleryIndex || 0) - 1);
        return;
      }
      if (e.target.closest('[data-fabric-gallery-next]')) {
        e.preventDefault();
        e.stopPropagation();
        showGallerySlide(gallery, (gallery._fabricGalleryIndex || 0) + 1);
        return;
      }
      if (e.target.closest('[data-fabric-gallery-zoom]')) {
        e.preventDefault();
        e.stopPropagation();
        openLightbox(getGallerySlides(gallery), gallery._fabricGalleryIndex || 0);
      }
    });

    var zoomBtn = gallery.querySelector('[data-fabric-gallery-zoom]');
    if (zoomBtn && !zoomBtn._fabricGalleryPreloadBound) {
      zoomBtn._fabricGalleryPreloadBound = true;
      zoomBtn.addEventListener('pointerenter', function () {
        preloadGallery(gallery);
      });
      zoomBtn.addEventListener('focus', function () {
        preloadGallery(gallery);
      });
    }
  }

  function initFabricGallery(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-fabric-gallery]:not([data-fabric-gallery-init]):not([data-fabric-gallery-source])').forEach(function (gallery) {
      gallery.setAttribute('data-fabric-gallery-init', 'true');
      gallery._fabricGalleryIndex = getActiveSlideIndex(gallery);
      bindGalleryControls(gallery);
    });
  }

  window.FabricGallery = {
    init: initFabricGallery,
    openLightbox: openLightbox,
    closeLightbox: closeLightbox,
    preload: preloadGallery
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFabricGallery(); });
  } else {
    initFabricGallery();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) initFabricGallery(section);
  });
})();
